// extracted by mini-css-extract-plugin
module.exports = {"sizeSmall":"PaymentIcons_sizeSmall__viMnk","sizeBig":"PaymentIcons_sizeBig__GUOFt"};